module.exports = __webpack_public_path__ + "img/9.ae4b6d03.jpg";